var TEN_YEARS_IN_SECONDS, setSiteCookies;

TEN_YEARS_IN_SECONDS = 60 * 60 * 24 * 365 * 10;

module.exports = setSiteCookies = function(cookies, seconds) {
  var cookieDomain, key, results, val;
  if (seconds == null) {
    seconds = TEN_YEARS_IN_SECONDS;
  }
  cookieDomain = setSiteCookies.cookieDomain || (setSiteCookies.cookieDomain = $('head').data('domain'));
  results = [];
  for (key in cookies) {
    val = cookies[key];
    if (val != null) {
      results.push(Cookie.set(key, val, seconds, cookieDomain));
    } else {
      results.push(Cookie.unset(key, cookieDomain));
    }
  }
  return results;
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL1VzZXJzL2FyaWNodGVyL3JlcG9zaXRvcmllcy9zbHMvY29yZS9mcm9udGVuZC9ncm91cG9uX21vZHVsZXMvc2V0U2l0ZUNvb2tpZXMuY29mZmVlIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiL1VzZXJzL2FyaWNodGVyL3JlcG9zaXRvcmllcy9zbHMvY29yZS9mcm9udGVuZC9ncm91cG9uX21vZHVsZXMvc2V0U2l0ZUNvb2tpZXMuY29mZmVlIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLElBQUE7O0FBQUEsb0JBQUEsR0FBdUIsRUFBQSxHQUFLLEVBQUwsR0FBVSxFQUFWLEdBQWUsR0FBZixHQUFxQjs7QUFHNUMsTUFBTSxDQUFDLE9BQVAsR0FBaUIsY0FBQSxHQUFpQixTQUFDLE9BQUQsRUFBVSxPQUFWO0FBQ2hDLE1BQUE7O0lBRDBDLFVBQVU7O0VBQ3BELFlBQUEsR0FBZSxjQUFjLENBQUMsaUJBQWYsY0FBYyxDQUFDLGVBQWlCLENBQUEsQ0FBRSxNQUFGLENBQVMsQ0FBQyxJQUFWLENBQWUsUUFBZjtBQUMvQztPQUFBLGNBQUE7O0lBQ0UsSUFBRyxXQUFIO21CQUNFLE1BQU0sQ0FBQyxHQUFQLENBQVcsR0FBWCxFQUFnQixHQUFoQixFQUFxQixPQUFyQixFQUE4QixZQUE5QixHQURGO0tBQUEsTUFBQTttQkFHRSxNQUFNLENBQUMsS0FBUCxDQUFhLEdBQWIsRUFBa0IsWUFBbEIsR0FIRjs7QUFERjs7QUFGZ0MifQ==
